import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const validateBusinessToken = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/auth/business/${token}`, {
            withCredentials: true,
            withXSRFToken: true,
        });
        return response.data;
    } catch (error) {
        console.error('Error validating business token:', error);
        throw error;
    }
};

export const sendSMSCode = async (phoneNumber) => {
    try {
        const response = await axios.post(`${API_URL}/auth/send-sms-code`, phoneNumber, {
            withCredentials: true,
            withXSRFToken: true,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error sending SMS code:', error);
        throw error;
    }
};

export const verifySMSLogin = async (phoneNumber, verificationCode) => {
    try {
        const response = await axios.post(
            `${API_URL}/auth/verify-sms-login`,
            {
                phoneNumber,
                verificationCode,
            },
            {
                withCredentials: true,
                withXSRFToken: true,
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error verifying SMS login:', error);
        throw error;
    }
};
